<template>
  <v-container class="d-flex1 align-center justify-center">
    <v-card
      class="d-flex align-center pa-0"
      rounded="pill"
      width="300"
      height="60"
      color="#eee"
    >
      <router-link
        :to="report.path"
        class="ma-0 pa-0 rounded text-none"
        height="100%"
        width="100%"
      >
        <v-btn
          class="ma-0 pa-0 rounded text-none mx-auto"
          rounded
          rel="noopener noreferrer"
          height="100%"
          width="100%"
          color="grey-lighten-1 text-yellow"
          style="font-family: tajawal; font-size: large; font-weight: bolder"
          >{{ report.title }}</v-btn
        >
      </router-link>
      <!-- <v-btn
        :href="this.$router.resolve({ name: report.name }).href"
        class="ma-0 pa-0 rounded text-none"
        rounded
        rel="noopener noreferrer"
        height="100%"
        width="100%"
        color="grey-lighten-1 text-yellow"
        style="font-family: tajawal; font-size: large; font-weight: bolder"
        >{{ report.title }}</v-btn
      > -->
    </v-card>
  </v-container>
</template>
<script>
export default {
  props: {
    report: Object,
  },
};
</script>
